import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const baseStyle = () => style.definePartsStyle({});

const toggleVariant = (theme: ThemesKeys) =>
  style.definePartsStyle({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    tab: {
      bg: getThemes(theme).colors.palette.neutral[90],
      borderRadius: 'full',
      fontWeight: 'bold',
      minWidth: 44,
      _selected: {
        bg: getThemes(theme).colors.palette.primary[100],
        boxShadow:
          '0 8px 8px 4px ' +
          getThemes(theme).colors.palette.neutral[60] +
          '29',
        border: '1px solid ' + getThemes(theme).colors.palette.neutral[90],
      },
    },
    tablist: {
      border: 'none',
      borderRadius: 'full',
      bg: getThemes(theme).colors.palette.neutral[90],
      p: '5px',
    },
    tabpanel: {
      border: 'none',
    },
  });

export const inputTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(),
    variants: {
      toggle: toggleVariant(theme),
    },
  });

export default (theme: ThemesKeys) => inputTheme(theme);
